module.exports = __webpack_public_path__ + "static/media/speaker.72a60a69.jpeg";